import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'ag-browse-table-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BrowseTablePagingComponent implements OnInit {
  @Input() initialOffset: string;
  @Input() currentOffset: string;
  @Input() previousOffset: string;
  @Input() nextOffset: string;
  @Output() paging: EventEmitter<string> = new EventEmitter();

  disablePrevious: boolean;

  ngOnInit() {
    this.disablePrevious = parseInt(this.initialOffset) === parseInt(this.currentOffset);
  }

  onPaging(nextOffset: string): void {
    this.paging.emit(nextOffset);
  }
}
